import { useState, useEffect, useCallback } from 'react';
import { userCacheService } from 'api/services/userCacheService';
import type { UserCache } from 'api/types';

export const useUserCache = () => {
  const [data, setData] = useState<UserCache[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await userCacheService.getAll();
      setData(response.data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchUsers(); }, [fetchUsers]);

  return { data, loading, error, refetch: fetchUsers };
};
